export type JadwalBlokir = {
  id: string
  hari: number        // 0=Minggu, 1=Senin, ..., 6=Sabtu
  jam_mulai: string   // '08:00:00'
  jam_selesai: string // '17:00:00'
  aktif: boolean
}

export type Category = {
  id: string
  nama: string
  slug: string
  gambar_url: string | null
  urutan: number
}

export type ProdukTipe = 'jual' | 'sewa' | 'jasa' | 'tour'

export type Produk = {
  id: string
  nama: string
  deskripsi: string
  harga: number
  harga_max: number | null
  tipe: ProdukTipe
  satuan: string
  stok: number
  gambar_url: string | null
  aktif: boolean
  sewa_per_hari: boolean
}

// 1=Menunggu Konfirmasi, 2=Dikonfirmasi, 3=Selesai, 4=Dibatalkan
// 5=Dipinjam (rental), 6=Dikembalikan (rental)
export type OrderStatusId = 1 | 2 | 3 | 4 | 5 | 6

export const ORDER_STATUS: Record<OrderStatusId, { label: string; color: string }> = {
  1: { label: 'Menunggu Konfirmasi', color: 'bg-yellow-100 text-yellow-700' },
  2: { label: 'Dikonfirmasi',        color: 'bg-blue-100 text-blue-700' },
  3: { label: 'Selesai',             color: 'bg-green-100 text-green-700' },
  4: { label: 'Dibatalkan',          color: 'bg-red-100 text-red-700' },
  5: { label: 'Dipinjam',            color: 'bg-purple-100 text-purple-700' },
  6: { label: 'Dikembalikan',        color: 'bg-teal-100 text-teal-700' },
}

export type Order = {
  id: string
  nomor_order: string | null
  pelanggan_id: string | null
  produk_id: string | null
  nama_produk: string
  harga_satuan: number
  qty: number
  subtotal: number
  nama_pemesan: string
  alamat: string | null
  no_hp: string | null
  tanggal_kirim: string
  jam_kirim: string | null
  metode_bayar: 'tunai' | 'transfer'
  rekening_id: string | null
  bukti_transfer_url: string | null
  status_id: OrderStatusId
  created_at: string
  updated_at: string
}
